/* eslint-disable no-unused-vars */
import { getStore } from "./services/store";
import { App } from "./services/action";
import { Auth } from "services/action";

// const POD_URL = `${process.env.REACT_APP_POD_SYSTEM_URL}`;
// const TMS_URL = `${process.env.REACT_APP_TMS_SYSTEM_URL}`;

export default async function bootstrap() {
  const { dispatch, getState } = getStore();
  const session = getState().Auth;

  if (!session?.session) {
    await dispatch(Auth.$setSession(null));
  }

  const id = window?.location?.pathname.split("/")[2];

  // if (window?.location?.pathname?.split("/")[1] === "blanko") {
  //   const shipment = await dispatch(Shipment.$getByCode(id));

  //   if (shipment?.message === "success" && shipment?.data) {
  //     window.open(`${POD_URL}/shipment/${shipment?.data?.id}`, "_self");
  //     await dispatch(App.$appReady());
  //   } else {
  //     window.open(`${TMS_URL}/shipment/activation/${id}`, "_self");
  //   }
  // }

  await dispatch(App.$appReady());
}
